function initDeliveryCourier($cartOrder, orderId) {
	let validCourierAddresses = [$(`#order-${orderId}-user_address-courier`).data('validAddress')];
	let $mapAddress = $(`#order-${orderId}-map-address`);

	if (typeof ymaps === 'undefined' || !$mapAddress.length)
		return;

	ymaps.ready(function () {
		console.log('ready')
		let suggestView = new ymaps.SuggestView(`order-${orderId}-user_address-courier`);

		suggestView.events.add('select', function (e) {
			let addr = $.trim(e.get('item').value);
			validCourierAddresses.push(addr);

			$(`#order-${orderId}-user_address-courier`).attr('data-old-addr', '');

			ymaps.geocode(addr, {results: 1}).then(function (res) {
				let firstGeoObject = res.geoObjects.get(0),
					coordinates = firstGeoObject.geometry.getCoordinates();

				$cartOrder.find('.input-coordinates').val(coordinates);
				let params = window.VegasOrder.formOrder().serializeArray();
				params.push({name: 'order_id', value: orderId});
				let $deliveryMsgError = $cartOrder.find(".tab-delivery-courier .msg-error");
				let $deliveryMsgSuccess = $cartOrder.find(".tab-delivery-courier .msg-success");

				$deliveryMsgSuccess.show().text('Рассчитываем стоимость доставки...');
				$deliveryMsgError.hide();

				$.get('/cart/order/get_courier_price', params, function (data) {
					$deliveryMsgError.hide();
					$deliveryMsgSuccess.hide();

					if (data.error) {
						if (data.type == 'no_delivery') {
							$deliveryMsgError
								.text('К сожалению, мы не сможем доставить заказ по данному адресу')
								.show();

							$('[data-order-sum=delivery]').html('<span class="text-danger">-</span>');
						}

						VegasOrder.disabledCourier = true;
						VegasOrder.renderOrderButtons();
					} else {
						$deliveryMsgSuccess
							.text('Доставка до двери: ' + (data.price ? output_roubles(data.price) : 'бесплатно'))
							.show();

						VegasOrder.disabledCourier = false;
						VegasOrder.renderOrderButtons();
					}
				});
			});
		});
	});

	$(`#order-${orderId}-user_address-courier`).on('blur', function () {
		let self = this;

		setTimeout(function () {
			let currentAddress = $(self).val();
			if (currentAddress) {
				let valid = false;
				for (let i in validCourierAddresses) {
					let validAddr = validCourierAddresses[i];
					if (!validAddr) continue;
					if (currentAddress.indexOf(validAddr) !== -1) {
						valid = true;
						break;
					}
				}

				if (!valid) {
					$(self).attr('data-old-addr', $(self).val());
					$(self).val('');
					alert('Выберите адрес из выпадающего списка!');
					window.VegasOrder.formOrder().find('[name=zones_data]').val('');
				}
			}
		}, 150);
	}).on('focus', function () {
		let addr = $(this).attr('data-old-addr');
		if (addr) {
			$(this).val(addr);
		}
	});
}

$(document).ready(function () {
	$('.cart-order').each(function () {
		let $cartOrder = $(this);
		let orderId = $cartOrder.data('order-id');

		setTimeout(() => {
			initDeliveryCourier($cartOrder, orderId);
		}, 2000);
	});
});